import React from 'react'
import styled from 'styled-components'
import TextHeader from '../../components/TextHeader'
import TabList from '../../components/TabList'
import Container from '../../Layout/Container'
import ReactMarkdown from 'react-markdown';

const StyledWrapper = styled.div`
  background: ${({ theme, ghost }) => ghost ? `#fff` : theme.colors.sectionLightBg};
  overflow: hidden;
  padding: 88px 20px 0;

  ${({ theme }) => theme.media.desktop} {
    padding: 88px 0px 18px;
  }
`

const StyledContainer = styled.div`
  flex-wrap: wrap;
  padding: 0;

  ${({ theme }) => theme.media.desktop} {
    flex-wrap: nowrap;
    margin-top: 40px;
    padding: 0 calc(8.333333%);
  }
`

const DoMoreWithEmail = ({data, ghost}) => {
  if(!data.edges){
    const edges = []
    const node = {
      node: {
        header: data.header,
        items: data.items,
      },
    }
    edges.push(node)
    delete data.items
    delete data.header
    data['edges'] = edges
  }

  const HeaderData = data.edges[0].node.header
  const SliderData = data.edges[0].node.items

  return (
    <StyledWrapper ghost={ghost}>
      <Container>
        <TextHeader
          title={
            <ReactMarkdown source={HeaderData.title.title}/>
          }
          subtitle={HeaderData.subtitleTop}
          text={HeaderData.text.text}
          theme={{ size: HeaderData.themeSize, align: HeaderData.themeAlign }}
        />
        <StyledContainer>
          <TabList tabs={SliderData} />
        </StyledContainer>
      </Container>
    </StyledWrapper>
  )
}

export default DoMoreWithEmail
